// @flow

class A {}
class B {}


class MyClass {
    constructor(a: A, b: B) {}
}
